// vuex模块：常量管理
export default {
  state: {
    // 菜品默认选多份
    FOOD_MULTIPLE_YES: 'YES',
    FOOD_MULTIPLE_NO: 'NO',
    // 菜品必填
    FOOD_REQUIRED_YES: 'YES',
    FOOD_REQUIRED_NO: 'NO',
    // 必选菜数量限制 (ATLSTONE=至少1分，PERPEOPLE=按人数)
    FOOD_REQUIRED_ATLSTONE: 'ATLSTONE',
    FOOD_REQUIRED_PERPEOPLE: 'PERPEOPLE',
    // 菜品要求必选
    FOOD_SETTING_MUST_YES: 'YES',
    // 菜品可用状态 USING：在用，UNUSED：未用
    FOOD_STATUS_USING: 'USING',
    FOOD_STATUS_UNUSED: 'UNUSED',
    // 菜品数量是否可为小数
    FOOD_CAN_FLOAT_YES: 'YES',
    // 菜品套餐 SET_MEAL
    FOOD_TYPE_SET_MEAL: 'SET_MEAL',
    // 套餐分组菜是否默认
    SET_MEAL_FOOD_DEFAULT_Y: 'Y',
    // 套餐分组菜是否必选
    SET_MEAL_FOOD_REQUIRED_Y: 'Y',
    SET_MEAL_FOOD_REQUIRED_N: 'N',
    // 套餐分组菜是否可重复选择
    SET_MEAL_FOOD_REPEAT_Y: 'Y',
    SET_MEAL_FOOD_REPEAT_N: 'N',
    // goods列表是否显示会员价 displayVipPrice (YES, NO)
    VIP_PRICE_DISPLAY_YES: 'YES',
    VIP_PRICE_DISPLAY_NO: 'NO',
    // 是否强制收集就餐人数
    PEOPLE_NUM_YES: 'YES',
    PEOPLE_NUM_NO: 'NO',
    // 是否预点餐订单
    PRE_ORDER_Y: 'Y',
    PRE_ORDER_N: 'N',
    // 订单状态（部分）
    ORDER_STATUS_PRE_ORDER: 'PRE_ORDER',
    // 储值规则类型：手机储值
    PAY_RULE_TYPE_ONLINE: 'ONLINE',
    // 是否只在使用储值余额支付时享有优惠
    CHEAP_PREPAID_ONLY: 'YES',
    // 是否享受会员优惠
    CHEAP_RATE_RIGHT: 'YES'

  }
}



// WEBPACK FOOTER //
// ./src/config/store.const.js